import { useQuery, keepPreviousData } from '@tanstack/react-query';

// Shared base for the paged Users list queries (GoTu Admins and Location
// Users): same options and { rows, totalCount, pageSize } shape.
export const useUsersPageQuery = (queryKey, queryFn, pageSize) => {
  const { data, error, isError, isPending, isFetching } = useQuery({
    queryKey,
    queryFn,
    retry: false,
    // Keeps the current page on screen while the next one loads, so paging and
    // typing in the search box do not blank the table.
    placeholderData: keepPreviousData,
  });

  return {
    rows: data?.data ?? [],
    // Nullish while unknown, never 0: useClampedPage reads a 0 as "one page"
    // and would reset the admin's page to 1 on top of a failed request.
    totalCount: data?.total ?? null,
    pageSize,
    isPending,
    isFetching,
    isError,
    error,
  };
};
